const getBase64ImageFromUrl = async imageUrl => {
  const res = await fetch(imageUrl);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

function getBase64PDFImagePNG(imgUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imgUrl;

    img.onload = () => {
      // eslint-disable-next-line no-undef
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };

    img.onerror = err => reject(err);
  });
}

function getBase64PDFImage(imgUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = imgUrl;

    img.onload = () => {
      // eslint-disable-next-line no-undef
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/jpeg');
      resolve(dataURL);
    };

    img.onerror = err => reject(err);
  });
}

function removeBeforeBase64(inputString) {
  const base64Index = inputString.indexOf('base64,');
  if (base64Index !== -1) {
    return inputString.substring(base64Index + 7); // Adding 7 to account for the length of "base64,"
  }
  return 'base64, not found in the input string.';
}

function openBase64Pdf(base64Content) {
  const decodedData = atob(base64Content);
  const byteArray = new Uint8Array(decodedData.length);

  for (let i = 0; i < decodedData.length; i++) {
    byteArray[i] = decodedData.charCodeAt(i);
  }

  const blob = new Blob([byteArray], { type: 'application/pdf' });
  const file = URL.createObjectURL(blob);
  document.open(file, '_blank', '');
}

function formatarIdadeMeses(dtNasc, dtExame) {
  if (!dtNasc || !dtExame) return '--';

  const nasc = new Date(dtNasc);
  const exame = new Date(dtExame);

  let anos = exame.getFullYear() - nasc.getFullYear();
  let meses = exame.getMonth() - nasc.getMonth();

  if (exame.getDate() < nasc.getDate()) {
    meses--;
  }

  if (meses < 0) {
    anos--;
    meses += 12;
  }

  const totalMeses = anos * 12 + meses;

  if (totalMeses >= 12) {
    const qtdAnos = Math.floor(totalMeses / 12);
    return `${qtdAnos} ${qtdAnos === 1 ? 'ano' : 'anos'}`;
  }

  if (totalMeses <= 0) {
    return 'Menos de 1 mês';
  }

  return `${totalMeses} ${totalMeses === 1 ? 'mês' : 'meses'}`;
}

const formatarData = (data) => {
  if (!data) return '';

  const date = new Date(data);

  return date.toLocaleDateString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
  });
};

function formatarHora(hrAgenda) {
  let ao_hora = String(hrAgenda);
  if (ao_hora.length < 4) {
    ao_hora = `0${ao_hora}`;
  }
  ao_hora = ao_hora.replace(/(\d{2})(\d{2})$/, '$1:$2'); // Coloca um hífen entre o terceiro e o quarto dígitos
  return ao_hora;
}

function formatarHorario(horario) {
  const hora = Math.floor(horario / 100);
  const minutos = horario % 100;
  return (
    hora.toString().padStart(2, '0') + ':' + minutos.toString().padStart(2, '0')
  );
}

function dataExtenso(data_informada) {
  const meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  const dia_informado = data_informada.split('/')[0];
  const mes_informado = data_informada.split('/')[1];
  const ano_informado = data_informada.split('/')[2];
  const data = `${ano_informado}-${mes_informado}-${dia_informado} 00:00:00`;
  const dataInfo = new Date(data);
  const dia = dataInfo.getDate();
  const mes = dataInfo.getMonth();
  const ano = dataInfo.getFullYear();
  const diaext = `${dia} de ${meses[mes]} de ${ano}`;
  return diaext;
}

function getPrefix(code) {
  const isProf = code === 1 || code === 5 || code === 2796 || code === 958;
  return isProf ? 'Prof. Dr. ' : 'Dr. ';
}

function prefixo(laudo) {
  const codMedico = laudo?.codMedico || laudo?.CODMEDICO;
  if (
    codMedico === 1 ||
    codMedico === 5 ||
    codMedico === 2796 ||
    codMedico === 958
  ) {
    return 'Prof. Dr.';
  }
  return 'Dr.';
}

const abreviarNome = nome => {
  if (!nome) return '-';

  const partes = nome
    .trim()
    .toLowerCase()
    .split(/\s+/);

  if (partes.length === 1) {
    return partes[0].replace(/\b\w/g, letra => letra.toUpperCase());
  }

  const primeiroNome = partes[0].replace(
    /\b\w/g,
    letra => letra.toUpperCase()
  );

  const ultimoNome = partes[partes.length - 1]
    .replace(/\b\w/g, letra => letra.toUpperCase());

  return `${primeiroNome} ${ultimoNome.charAt(0)}.`;
};

/**
 * Calendar day at midnight BRT (UTC-3). Same contract as agenda `dateAgendaFormatted`.
 * Prefer the literal yyyy-MM-dd from strings so `new Date('yyyy-MM-dd')` UTC off-by-one
 * does not shift the day when the backend does `new Date(payload)`.
 */
function toBrazilMidnightIso(value) {
  if (value == null || value === '') return '';

  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, year, month, day] = match;
      return `${year}-${month}-${day}T00:00:00-03:00`;
    }
  }

  const date =
    value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  date.setHours(0, 0, 0, 0);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00-03:00`;
}

function goToNextInput(event, nextInputId) {
  if (event.key === 'Enter') {
    const nextInput = document.getElementById(nextInputId);
    if (nextInput) {
      nextInput.focus();
      nextInput.select();
    }
  }
}

// ---------------- ESCALONAMENTO DE FONTE ----------------
const scaleStyles = (styles, scale = 1.0) => {
  const newStyles = {};

  for (const key in styles) {
    const originalStyle = styles[key];
    // Cria uma cópia do objeto para não mutar o original
    const scaledStyle = { ...originalStyle };

    if (scaledStyle.fontSize) {
      scaledStyle.fontSize = Math.round(scaledStyle.fontSize * scale);
    }
    if (scaledStyle.lineHeight) {
      scaledStyle.lineHeight = Number(
        (scaledStyle.lineHeight * scale).toFixed(2)
      );
    }

    newStyles[key] = scaledStyle;
  }
  return newStyles;
};

// ---------------- STYLES BASE ----------------
const baseStyles = {
  title: { fontSize: 18, bold: true, alignment: 'center', margin: [0, 5] },
  content: { fontSize: 12, lineHeight: 1.2 },
  observations: { fontSize: 12, lineHeight: 1.2 },
  files: { fontSize: 11, lineHeight: 1.1 },
  footer: { fontSize: 10 },
  small: { fontSize: 10 },
  smaller: { fontSize: 9 },
};

export {
  getBase64ImageFromUrl,
  getBase64PDFImage,
  getBase64PDFImagePNG,
  removeBeforeBase64,
  openBase64Pdf,
  dataExtenso,
  formatarIdadeMeses,
  formatarData,
  formatarHora,
  formatarHorario,
  getPrefix,
  prefixo,
  toBrazilMidnightIso,
  goToNextInput,
  scaleStyles,
  baseStyles,
  abreviarNome,
};
